import type { TipoManutencao } from "@/modules/financeiro-obras";
import { PROJECAO_TITLE } from "./etapa-projecao/etapa-projecao.constants";

export const ADICIONAR_ESCOPO_TITLE = "Adicionar Escopo macro";
export const ETAPAS_LABEL = "Etapas do escopo macro";
export const ETAPA_DADOS = "Dados do escopo";
export const ETAPA_PROJECAO = PROJECAO_TITLE;

export const DADOS_TITLE = "Dados do escopo macro";
/** Figma 14146:390010. */
export const INFO_TIPOS_DA_OBRA =
  "Só aparecem os Tipos de Obra do centro escolhido. Para outro centro, use “+ Adicionar Centro de Custo”; para outro tipo, “+ Adicionar novo Tipo de Obra”.";

export const CENTRO_CUSTO_LABEL = "Centro de custo";
export const TIPO_OBRA_LABEL = "Tipo de Obra";
export const SELECIONE_PLACEHOLDER = "Selecione";
export const SEM_TIPO_DISPONIVEL = "Nenhum tipo de obra disponível";
/** Último item da lista de Centros de Custo (Figma 17085:473969); fica desabilitado até o fluxo existir. */
export const ADICIONAR_CENTRO_LABEL = "+ Adicionar Centro de Custo";
export const ADICIONAR_CENTRO_VALOR = "adicionar-centro-custo";
/** Último item da lista de Tipos de Obra, que abre a inclusão da HU 2715 sem gravar (Figma 14146:390010). */
export const ADICIONAR_TIPO_LABEL = "+ Adicionar novo Tipo de Obra";
export const ADICIONAR_TIPO_VALOR = "adicionar-tipo-obra";
export const CRIADO_AO_CONCLUIR_TAG = "Será criado ao concluir";
/** Ajuda sob o Centro ou o Tipo escolhido no subfluxo (Figma 17085:474116). */
export const ENTRA_AO_SALVAR_AJUDA = "Entra na Obra quando o escopo macro for salvo.";

export const EM_APROVACAO_TAG = "Em aprovação";

export const CANCELAR_LABEL = "Cancelar";
export const VOLTAR_LABEL = "Voltar";
export const PROXIMA_LABEL = "Próxima etapa";

export const SALVAR_SEM_PROJECAO_LABEL = "Salvar sem projeção";

/** Figma 13027:297512. */
export const NOVO_ESCOPO_TITLE = "Novo escopo macro";
export const PADRAO_LABEL = "Padrão";
export const PERSONALIZADO_LABEL = "Personalizado";
export const ALTERNATIVAS_LABEL = "Forma do escopo macro";
export const ESCOPO_MACRO_LABEL = "Escopo macro";
export const ESCOPO_TEXTO_PLACEHOLDER = "Descreva o escopo macro";
export const INICIO_LABEL = "Início previsto";
export const FIM_LABEL = "Fim previsto";
export const ORIGEM_LABEL = "Origem";
export const DESCRICAO_LABEL = "Descrição";
export const DESCRICAO_PLACEHOLDER = "Descrição (opcional)";

/** Limites únicos do formulário; o core confere de novo. */
export const ESCOPO_TEXTO_MAX = 255;
export const DESCRICAO_MAX = 500;

export const FORA_DO_PERIODO = "Fora do período permitido. Corrija a data.";
export const FIM_ANTES_DO_INICIO = "O fim não pode ser anterior ao início.";
export const DESCRICAO_LIMITE = `A descrição aceita até ${DESCRICAO_MAX} caracteres.`;
export const ESCOPO_TEXTO_LIMITE = `O escopo macro aceita até ${ESCOPO_TEXTO_MAX} caracteres.`;

export const ESCOPOS_PADRAO_VAZIO =
  "Este Tipo de Obra não tem escopo padrão. Use Personalizado para descrever o escopo.";
export const ESCOPO_JA_INCLUIDO = "Já incluído neste Tipo de Obra";
export const SELECIONE_ESCOPO_PLACEHOLDER = "Selecione o escopo macro";

export const FALHA_ORIGENS = "Não foi possível carregar as origens. Tente novamente.";

export const ERRO_ENVIO_PADRAO = "Não foi possível incluir o escopo macro. Tente novamente.";

/** Troca com dado abaixo: botões Manter e Trocar (Figma 17402:558163; o texto não está no nó). */
export const TROCA_ACEITAR_LABEL = "Trocar";
export const TROCA_MANTER_LABEL = "Manter";
export const TROCA_HEADER = (campo: string) => `Trocar ${campo}?`;
export const TROCA_MESSAGE =
  "Ao trocar, o que foi preenchido abaixo será apagado. Deseja trocar ou manter o valor atual?";
export const CAMPO_TROCA = {
  centroCusto: "o centro de custo",
  tipoObra: "o Tipo de Obra",
  grupo: "o Grupo",
  equipamento: "o equipamento",
} as const;

/** Aviso por FEL e as mensagens de sucesso: sem projeção o toast é o desta tela (D2); com projeção vale a mensagem do core e a daqui só entra se ela vier vazia. */
export const TEXTOS_POR_FEL = {
  efetivacaoImediata: {
    aviso: null,
    concluirLabel: "Adicionar escopo macro",
    sucessoSemProjecao: (_escopo: string) => "Escopo Macro incluído sem projeção financeira.",
    sucessoComProjecao: "Escopo Macro incluído com projeção financeira.",
    sucessoTom: "success",
  },
  aprovacao: {
    aviso: (fel: string) =>
      `A Obra está em ${fel}. A inclusão será enviada para aprovação e só entra no planejamento depois de aprovada.`,
    concluirLabel: "Solicitar inclusão",
    sucessoSemProjecao: (escopo: string) =>
      `Solicitação de inclusão do Escopo Macro ${escopo} enviada para aprovação.`,
    sucessoComProjecao: "Solicitação de inclusão enviada para aprovação.",
    sucessoTom: "info",
  },
} as const;

export const TIPOS_MANUTENCAO: TipoManutencao[] = [
  "Intermediária",
  "Overhaul",
  "Manutenção Corretiva",
];
export const TIPO_MANUTENCAO_CORRETIVA: TipoManutencao = "Manutenção Corretiva";

/** Figma 13027:297512 e HU 2711 (Tipo 103). */
export const GRUPO_LABEL = "Grupo";
export const EQUIPAMENTO_LABEL = "Equipamento";
export const FABRICANTE_LABEL = "Fabricante";
export const MODELO_LABEL = "Modelo";
export const TIPO_MANUTENCAO_LABEL = "Tipo de manutenção";
export const REVISAO_LABEL = "Revisão";
export const NOME_COMPOSTO_LABEL = "Nome do escopo";
export const REVISAO_SEM_VALOR = "—";
export const SEM_EQUIPAMENTO = "Nenhum equipamento disponível para esta embarcação.";
export const FALHA_EQUIPAMENTOS = "Não foi possível carregar os equipamentos. Tente novamente.";

/** Tooltip do item de novo Centro de Custo sem Centro com Tipo para incluir; sem Figma. */
export const SEM_CENTRO_CUSTO_ELEGIVEL =
  "Nenhum centro de custo desta Obra tem Tipo de Obra disponível para inclusão.";
